export function initGallery($) {
  /* ========================================================================= *\
  **  === Isotope                                                              *| 
  \* ========================================================================= */


  if($('.gallery--grid')) {
    var $grid = $('.gallery--grid').isotope({
      itemSelector: '.gallery--item',
    });

    
    $('body').on( 'click', '.gallery--filter', function() {
      var filterValue = $(this).attr('data-filter');
      $grid.isotope({ filter: filterValue });
      
      $('.gallery--filter').removeClass('is-active')
      $(this).addClass('is-active')
    });

    $('body').on( 'click, mouseenter', '.gallery--filter-locations', function(){
      $('.gallery--locations').toggleClass('is-active');
      $('.gallery--filters-chevron').toggleClass('is-active');
    })

    $('body').on( 'mouseleave', '.gallery--filter-locations', function(){
      $('.gallery--locations').removeClass('is-active');
      $('.gallery--filters-chevron').removeClass('is-active');
    })

  }
}
